import { createSettingsListSection } from "../../SettingsListSection";
import Scale from "../../../../../models/Scale";

export const scaleDataComponentId = "dataComponentScale";

export default createSettingsListSection({
  dataComponentId: scaleDataComponentId,
  model: Scale,
  apiRoute: "scales",
  label: "Scale",
  pluralLabel: "Scales",
  createModal: "CreateScale",
  editModal: "EditScale",
  editModalEntityKey: "scale",
  permissions: ["manage-scales"],
});
